module.exports = __webpack_public_path__ + "trends.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/trends.svg
// module id = 113
// module chunks = 0